<ng-container *ngIf="isBrowser && !isGoogle">
    <div class="container" [class.h30]="showText">
        <div class="scrolling-text" #el>
            <ng-container *ngIf="showText">
                <ng-container *ngFor="let lt of lauftexts">
                    <a multilang [href]="lt.link" class="linka" (mouseover)="player?.pause()"
                        (mouseout)="player?.play()">
                        {{lt.text}}
                        <mat-icon class="cc1">open_in_new
                        </mat-icon>
                        <span multilang class="cc2">---</span>
                    </a>
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-container>